import { getAmplitudeInstance } from '../amplitudeHelpers';

type logGarminConnectSucceededParams = {
  trail_id?: number;
};

/**
 * User is successfully connected to Garmin. This should trigger for both connecting to Garmin from Settings or via Send to Garmin. For iOS, see the equivalent ThirdPartyConnectionChanged event which was launched with launch of Coros in H1 2026.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail page the user was on when they tapped a link to complete an action.
 */
const logGarminConnectSucceeded = ({ trail_id }: logGarminConnectSucceededParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('garmin connect succeeded', { 'trail id': trail_id }, callback);
};

export default logGarminConnectSucceeded;
